import s from './Common.module.scss';

const Loader = () => {
  return <div className={s.loader}></div>;
};

export default Loader;
